// A aliquota INTERESTADUAL padrao do Confaz: depende so do par de estados
// (origem -> destino), nao do produto. Pedido dela em 08/09/2026 -- travava o
// teste toda vez que escolhia um produto sem aliquota importada em
// aliquotas_icms. resolverImposto.ts usa esta funcao como PADRAO quando nao
// ha linha especifica para o produto; a importada, quando existir, continua
// vencendo (o padrao nunca sobrescreve o que ela cadastrou na mao).
//
// A UNICA excecao real e produto IMPORTADO (>40% de conteudo estrangeiro,
// sempre 4%, Resolucao do Senado 13/2012) -- essa e por produto, nao por
// estado. Ela confirmou que os produtos dela sao nacionais e pode ficar de
// fora por ora; o dia que precisar, entra como outro dado do produto (tipo
// ipi_pct), nao aqui -- esta funcao so sabe o par de estados.
const GRUPO_SUDESTE_SUL_SEM_ES: ReadonlySet<string> = new Set([
  'SP', 'RJ', 'MG', 'PR', 'SC', 'RS',
])

export function icmsInterestadualPadrao(ufOrigem: string, ufDestino: string): number {
  if (!GRUPO_SUDESTE_SUL_SEM_ES.has(ufOrigem)) return 12
  return GRUPO_SUDESTE_SUL_SEM_ES.has(ufDestino) ? 12 : 7
}
